export default {"src":"/_next/static/image/public/images/ic_plus_green.91016dfb7a55178bc5dfa9cdaaed0aeb.svg","height":14,"width":14};